export const getSystemInfoErrMsg = 'Ошибка получения информации о системе'
export const getSystemSettingsErrMsg = 'Ошибка получения системных настроек'
